import { Ce } from './Ce';

class TrainingPlanProgram extends Ce {
    constructor() {
        super();
        this.baseUrl += '/trainingPlanProgram';
    }

    data({
        certCatId,
        certExamType,
        programName,
        templateName,
        isAvailable,
        isRelVerticalGrouping,
        verticalGroupingName,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            certCatId,
            certExamType,
            programName,
            templateName,
            isAvailable,
            isRelVerticalGrouping,
            verticalGroupingName,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        programName,
        trainingPlanTemplateId,
        isAvailable,
        remarks,
        programTimeBegin,
        programDetailJson,
        programTimeType,
        theoryExamTime,
    } = {}) {
        return super.post('/save', {
            id,
            programName,
            trainingPlanTemplateId,
            isAvailable,
            remarks,
            programTimeBegin,
            programDetailJson,
            programTimeType,
            theoryExamTime,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    getDefaultTeacherList({ trainingPlanTemplateId, trainingPlanProgramId, programTimeBegin }) {
        return super.get('/getDefaultTeacherList', { trainingPlanTemplateId, trainingPlanProgramId, programTimeBegin });
    }

    getDefaultClassroomList({ trainingPlanTemplateId, trainingPlanProgramId, programTimeBegin }) {
        return super.get('/getDefaultClassroomList', {
            trainingPlanTemplateId,
            trainingPlanProgramId,
            programTimeBegin,
        });
    }
}

export default new TrainingPlanProgram();
export { TrainingPlanProgram };
